import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      home: {
        title: "Welcome to Greenbox Mobile Energy Charging Network",
        start: "Scan QR-Code to start",
      },
      status: {
        payment: "Continue to payment",
        scanAgain: "Scan another station",
        perkWh: "per kWh",
        price: "Price",
        power: "Maximum (kW)",
        notFound: "Station not found",
      },
      checkout: {
        connector: "Connector",
        connectorSelected: "Connector Selected",
        paymentSuccess: "Payment successful",
        paymentSuccesSubtitle: "Pre-authorization confirmed",
        startCharging: "Start charging",
        startChargingSubtitle: "Press continue button",
        continue: "Continue",
        paymentUnsuccessful: "Payment unsuccessful",
        paymentUnsuccessfulSubtitle: "Please try again",
        back: "Go back",
        startedCharging: "Charging started successfully",
        aboutToStartCharging: "Charging is about to start",
      },
      transaction: {
        chargerId: "Charger Station",
        price: "Price",
        consumption: "Consumption",
        pricePerKWh: "Price per kWh",
        stop: "Stop Charging",
        confirmStop: "End the charging session",
        confirmStopMessage: "Are you sure you want to stop charging?",
        duration: "Duration",
      },
      common: {
        cancel: "Cancel",
        confirm: "Confirm",
        found: "Station found",
        errorStop: "Error during stop charging process",
        start: "Start",
        end: "End",
        agree: "I agree to ",
        terms: "terms and conditions",
        available: "Available",
        occupied: "Occupied",
        stationNotAvailable: "Station not available",
        wrong: "Something went wrong. Please try again",
      },
    },
  },
  de: {
    translation: {
      home: {
        title: "Willkommen beim Greenbox Mobile Energy Ladenetzwerk",
        start: "QR-Code scannen zum Starten",
      },
      status: {
        payment: "Weiter zur Zahlung",
        scanAgain: "Andere Station scannen",
        perkWh: "pro kWh",
        power: "Leistung",
        price: "Preis",
        notFound: "Station nicht gefunden",
      },
      checkout: {
        connector: "Anschluss",
        connectorSelected: "Anschluss ausgewählt",
        paymentSuccess: "Zahlung erfolgreich",
        paymentSuccesSubtitle: "Vorautorisierung bestätigt",
        startCharging: "Ladevorgang starten",
        startChargingSubtitle: "Drücken Sie den Weiter-Button",
        continue: "Weiter",
        paymentUnsuccessful: "Zahlung fehlgeschlagen",
        paymentUnsuccessfulSubtitle: "Bitte versuchen Sie es erneut",
        back: "Zurück",
        startedCharging: "Ladevorgang erfolgreich gestartet",
        aboutToStartCharging: "Der Ladevorgang beginnt gleich",
      },
      transaction: {
        chargerId: "Ladegerät-ID",
        price: "Preis",
        consumption: "Verbrauch",
        pricePerKWh: "Preis pro kWh",
        stop: "Ladevorgang beenden",
        confirmStop: "Ladevorgang beenden",
        confirmStopMessage:
          "Sind Sie sicher, dass Sie den Ladevorgang beenden möchten?",
        duration: "Dauer",
      },
      common: {
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        found: "Station gefunden",
        errorStop: "Fehler beim Beenden des Ladevorgangs",
        start: "Start",
        end: "Ende",
        agree: "Ich stimme den ",
        terms: "Geschäftsbedingungen zu",
        available: "Verfügbar",
        occupied: "Besetzt",
        stationNotAvailable: "Station nicht verfügbar",
        wrong: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut",
      },
    },
  },
  es: {
    translation: {
      home: {
        title: "Bienvenido a la Red de Carga de Energía Móvil Greenbox",
        start: "Escanear código QR para comenzar",
      },
      status: {
        payment: "Continuar al pago",
        scanAgain: "Escanear otra estación",
        perkWh: "por kWh",
        power: "Potencia",
        price: "Precio",
        notFound: "Estación no encontrada",
      },
      checkout: {
        connector: "Conector",
        connectorSelected: "Conector seleccionado",
        paymentSuccess: "Pago exitoso",
        paymentSuccesSubtitle: "Pre-autorización confirmada",
        startCharging: "Comenzar carga",
        startChargingSubtitle: "Presione el botón continuar",
        continue: "Continuar",
        paymentUnsuccessful: "Pago fallido",
        paymentUnsuccessfulSubtitle: "Por favor intente nuevamente",
        back: "Volver",
        startedCharging: "Carga iniciada con éxito",
        aboutToStartCharging: "La carga está a punto de comenzar",
      },
      transaction: {
        chargerId: "ID del cargador",
        price: "Precio",
        consumption: "Consumo",
        pricePerKWh: "Precio por kWh",
        stop: "Detener carga",
        confirmStop: "Finalizar la sesión de carga",
        confirmStopMessage: "¿Está seguro que desea detener la carga?",
        duration: "Duración",
      },
      common: {
        cancel: "Cancelar",
        confirm: "Confirmar",
        found: "Estación encontrada",
        errorStop: "Error durante el proceso de detención de carga",
        start: "Inicio",
        end: "Fin",
        agree: "Acepto los ",
        terms: "términos y condiciones",
        available: "Disponible",
        occupied: "Ocupado",
        stationNotAvailable: "Estación no disponible",
        wrong: "Algo salió mal. Por favor, inténtelo de nuevo",
      },
    },
  },
  fr: {
    translation: {
      home: {
        title: "Bienvenue sur le Réseau de Recharge Greenbox Mobile Energy",
        start: "Scanner le QR-Code pour commencer",
      },
      status: {
        payment: "Continuer vers le paiement",
        scanAgain: "Scanner une autre station",
        perkWh: "par kWh",
        price: "Prix",
        power: "Puissance maximale (kW)",
        notFound: "Station non trouvée",
      },
      checkout: {
        connector: "Connecteur",
        connectorSelected: "Connecteur sélectionné",
        paymentSuccess: "Paiement réussi",
        paymentSuccesSubtitle: "Pré-autorisation confirmée",
        startCharging: "Démarrer la charge",
        startChargingSubtitle: "Appuyez sur le bouton continuer",
        continue: "Continuer",
        paymentUnsuccessful: "Paiement échoué",
        paymentUnsuccessfulSubtitle: "Veuillez réessayer",
        back: "Retour",
        startedCharging: "Charge démarrée avec succès",
        aboutToStartCharging: "La charge va commencer",
      },
      transaction: {
        chargerId: "Station de recharge",
        price: "Prix",
        consumption: "Consommation",
        pricePerKWh: "Prix par kWh",
        stop: "Arrêter la charge",
        confirmStop: "Terminer la session de charge",
        confirmStopMessage: "Êtes-vous sûr de vouloir arrêter la charge ?",
        duration: "Durée",
      },
      common: {
        cancel: "Annuler",
        confirm: "Confirmer",
        found: "Station trouvée",
        errorStop: "Erreur lors de l'arrêt de la charge",
        start: "Début",
        end: "Fin",
        agree: "J'accepte les ",
        terms: "conditions générales",
        available: "Disponible",
        occupied: "Occupé",
        stationNotAvailable: "Station non disponible",
        wrong: "Une erreur est survenue. Veuillez réessayer",
      },
    },
  },
  it: {
    translation: {
      home: {
        title: "Benvenuto alla Rete di Ricarica Greenbox Mobile Energy",
        start: "Scansiona il QR-Code per iniziare",
      },
      status: {
        payment: "Procedi al pagamento",
        scanAgain: "Scansiona un'altra stazione",
        perkWh: "per kWh",
        price: "Prezzo",
        power: "Potenza massima (kW)",
        notFound: "Stazione non trovata",
      },
      checkout: {
        connector: "Connettore",
        connectorSelected: "Connettore selezionato",
        paymentSuccess: "Pagamento riuscito",
        paymentSuccesSubtitle: "Pre-autorizzazione confermata",
        startCharging: "Avvia ricarica",
        startChargingSubtitle: "Premi il pulsante continua",
        continue: "Continua",
        paymentUnsuccessful: "Pagamento non riuscito",
        paymentUnsuccessfulSubtitle: "Per favore riprova",
        back: "Indietro",
        startedCharging: "Ricarica avviata con successo",
        aboutToStartCharging: "La ricarica sta per iniziare",
      },
      transaction: {
        chargerId: "Stazione di ricarica",
        price: "Prezzo",
        consumption: "Consumo",
        pricePerKWh: "Prezzo per kWh",
        stop: "Interrompi ricarica",
        confirmStop: "Termina sessione di ricarica",
        confirmStopMessage: "Sei sicuro di voler interrompere la ricarica?",
        duration: "Durata",
      },
      common: {
        cancel: "Annulla",
        confirm: "Conferma",
        found: "Stazione trovata",
        errorStop: "Errore durante l'interruzione della ricarica",
        start: "Inizio",
        end: "Fine",
        agree: "Accetto i ",
        terms: "termini e condizioni",
        available: "Disponibile",
        occupied: "Occupato",
        stationNotAvailable: "Stazione non disponibile",
        wrong: "Qualcosa è andato storto. Per favore riprova",
      },
    },
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "de", "es", "fr", "it"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
